import React from "react";
import PropTypes from "prop-types";
import {
  // ActivityDropdown,
  ActivityDropdownOne,
  ActivityTypeContainer,
  // CustomMenuItem,
  CustomMenuItemOne,
  // DropdownArrow,
  FieldTitle,
  NewActivityDropdownCommon,
  StyledLabel,
  TitleContainer,
} from "./style";
import { Dropdown } from "react-bootstrap";
import { DropIcon } from "../../../utils/icons";
import { getMonthName } from "../../../utils/methods";
import dayjs from "dayjs";

export default function CommonDropdown ({
  type,
  tileContainerStyle,
  // dropdownOpen,
  // dropdownOpen,
  // dropdownStyle,
  labelText,
  isRequired,
  disabled,
  height,
  //activityDropdownStyle,
  placeholder,
  title,
  // id,
  //onClick,
  data,
  onSelect,
  onClick,
  onSelectParameter,
  active,
  fontSize,
  //notActive,
  itemValue,
  activeValue,
  displayValue,
  valueString,
  t,
  valueIndex,
  //customMenuItemStyle,
  selectedClassCategory,
  isChallengeWellness,
  createEventUI,
  labelMargin,
  hideArrowIcon,
  isManagerMargin,
  dropIcon,
  // icon,
  // top,
  showWrapText,
  isSubText,
  showMonthName,
  // dropdownButtonPadding,
  showDateRange,
  dateRangeKeys,
  optionsHeight
}) {
  return (
    <React.Fragment>
      {type !== "challangeDropdown" && <TitleContainer tileContainerStyle={tileContainerStyle} heightV={optionsHeight}>
        {labelText ? <StyledLabel fontSize={fontSize} labelMargin={labelMargin}>
          {labelText}
          {isSubText ? <span className="subtext">{isSubText}</span> : null}
          {isRequired ? <span>*</span>  : null}
        </StyledLabel> : null}

        {/* New dropdown */}
        <NewActivityDropdownCommon
          onClick={()=>{!disabled && onClick()}}
          onSelect={(index, /*key*/) => {
            if(!disabled){
              if(valueString){
                onSelect(data[index], valueString);
              }else
              {
                onSelect(data[index]);
              }
              
            }

          }
          }
          createEventUI={createEventUI}
          disabled={disabled}
          height={height}
          isManagerMargin={isManagerMargin}
        >
          <Dropdown.Toggle>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center", color:disabled ? "rgba(0, 92, 135, 0.30)" :(!title || title != 0 || disabled && "#005C874D"),fontFamily:"Lato"}}>
              <div style={{color:disabled ? "#BDBDBD" : (title === undefined || title === "" || title === null) ? "#BDBDBD": "#184A61",}}>{title || title === 0? title:  placeholder?placeholder: "Select Option"}</div>
              {!hideArrowIcon && (
                disabled ? (
                  <div style={{marginLeft:'15px'}}>
                    {  dropIcon ?
                      <div>{DropIcon("#DA6C74")}</div>:
                      <img alt="image" src="/public/images/disabledDownArrow.png" />
                    }
                  </div>
                ) : (
                  <div style={{marginLeft:'15px'}}>
                    { dropIcon ? 
                      <div>{DropIcon("#DA6C74")}</div>:
                      <img alt="image" src="/public/images/teamDownArrow.svg" />
                    }
                  </div>
                )
              )}
            </div>
          </Dropdown.Toggle>
          <Dropdown.Menu>
            {data?.map((item, index) => {
              const startKey = dateRangeKeys?.start;
              const endKey = dateRangeKeys?.end;
            
              return (
                <Dropdown.Item 
                  eventKey={index}
                  key={index}
                  active={item === selectedClassCategory ? true : false}
                >
                  {showDateRange  
                    ? `${dayjs(item[startKey]).format("MMM YYYY")} - ${dayjs(item[endKey]).format("MMM YYYY")}`
                    : showMonthName
                      ? item[onSelectParameter[1]] != null ? getMonthName(item[onSelectParameter[1]]) + " - " : ""
                      : null
                  }
            
                  {!showDateRange && (
                    showWrapText
                      ? `${item[onSelectParameter[2]]}${index===0?"":" - "}${item[onSelectParameter[0]]}`
                      : itemValue
                        ? `${item[onSelectParameter[valueIndex]]} ${valueString ? valueString : ""}`
                        : `${item} ${valueString ? valueString : ""}`
                  )}
                </Dropdown.Item>
              );
            })}
          </Dropdown.Menu>
        </NewActivityDropdownCommon>
      </TitleContainer>
      }
      {
        type === "challangeDropdown" &&  
        <ActivityTypeContainer marginTop={isChallengeWellness}>
          <FieldTitle>{labelText}:</FieldTitle>
          <ActivityDropdownOne
            title={title}
            id="dropdown-basic"
            onSelect={(index) =>
            {!disabled && onSelect(onSelectParameter[0],
              itemValue ? data[index][onSelectParameter[1]] : data[index],
              data[index][onSelectParameter[2]])
            }
            }
            disabled={disabled}
          >
            {
              data.map((item, index) => (
                <CustomMenuItemOne
                  eventKey={index}
                  key={index}
                  active={active == (activeValue ? item[onSelectParameter[1]] : item)}
                >
                  { displayValue ? `${t(item[onSelectParameter[valueIndex]])} ` : `${t(item)} ${valueString ? `${t("Weeks")}` : ""}`}
                </CustomMenuItemOne>
              ))
            }
          </ActivityDropdownOne>
        </ActivityTypeContainer>
      }
    </React.Fragment>
  );
}

CommonDropdown.propTypes = {
  type : PropTypes.string,
  labelText: PropTypes.string,
  title: PropTypes.string,
  id: PropTypes.string,
  height: PropTypes.string,
  dropdownOpen:PropTypes.bool,
  data: PropTypes.array.isRequired,
  onSelect: PropTypes.func,
  active: PropTypes.any,
  isRequired :PropTypes.bool,
  onClick: PropTypes.func,
  onSelectParameter: PropTypes.array,
  notActive: PropTypes.any,
  valueString:PropTypes.any,
  itemValue:PropTypes.bool,
  valueIndex:PropTypes.number,
  dropdownStyle:PropTypes.obj,
  tileContainerStyle:PropTypes.obj,
  activityDropdownStyle :PropTypes.obj,
  customMenuItemStyle:PropTypes.any,
  t:PropTypes.any,
  activeValue:PropTypes.bool,
  displayValue:PropTypes.bool,
  disabled:PropTypes.any,
  role:PropTypes.any,
  selectedClassCategory: PropTypes.string,
  isChallengeWellness: PropTypes.bool,
  createEventUI: PropTypes.bool,
  labelMargin:PropTypes.string,
  placeholder: PropTypes.string,
  icon:PropTypes.string,
  hideArrowIcon:PropTypes.bool,
  isManagerMargin:PropTypes.string,
  dropIcon:PropTypes.node,
  fontSize:PropTypes.string,
  top: PropTypes.string,
  showWrapText: PropTypes.bool,
  isSubText: PropTypes.string,
  showMonthName:PropTypes.bool,
  showDateRange:PropTypes.bool,
  dateRangeKeys:PropTypes.object,
  optionsHeight:PropTypes.string
};
